import {defineStore} from 'pinia'
import {type ApiTokenNs} from "@shared/types";
import {ApiTokenApi} from "@/api/api-token.apis";


export const useApiTokenStore = defineStore("apiToken", {
  state: () => ({
    tokenMap: new Map<string, ApiTokenNs.ApiToken>
  }),
  getters: {},
  actions: {
    async loadApiToken(
        payload: ApiTokenNs.ApiTokenRequest
    ): Promise<ApiTokenNs.ApiToken> {
      return ApiTokenApi.getToken(payload)
      .then((response: ApiTokenNs.ApiToken) => {
        this.tokenMap.set(response.type, response)
        return response;
      })
    },

    async createApiToken(
        payload: ApiTokenNs.ApiTokenRequest
    ): Promise<ApiTokenNs.ApiToken> {
      return ApiTokenApi.createToken(payload)
      .then((response: ApiTokenNs.ApiToken) => {
        this.tokenMap.set(response.type, response)
        return response;
      })
    },

    async removeApiToken(
        payload: ApiTokenNs.ApiTokenRequest
    ): Promise<ApiTokenNs.ApiToken> {
      return ApiTokenApi.removeToken(payload)
      .then((response: ApiTokenNs.ApiToken) => {
        this.tokenMap.set(response.type, response)
        return response;
      })
    }

  }
})
